import { GET_DEPARTAMENTOS, GET_OPERADORES, GET_FILAS, GET_PAUSAS } from "./mutations-types";

export default {
  [GET_DEPARTAMENTOS]: (state, departamentos) => {
    state.departamentos = departamentos;
  },
  [GET_OPERADORES]: (state, operadores) => {
    state.operadores = operadores;
  },
  [GET_FILAS]: (state, filas) => { 
    state.filas = filas;
  },
  [GET_PAUSAS]: (state, pausas) => {
    state.pausas = pausas
  },
}
